/* 🤖 this file was generated by svg-to-ts*/
export const icoLocation: {
  name: 'location';
  data: string;
} = {
  name: 'location',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2a7 7 0 017 7c0 1.056-.235 2.08-.647 2.934-.892 2.379-2.734 5.58-5.53 9.634a1 1 0 01-1.646 0l-.606-.887c-2.458-3.636-4.096-6.539-4.89-8.668A7 7 0 0112 2zm0 2a5 5 0 00-5 5c0 .756.167 1.486.519 2.23.668 1.782 1.96 4.144 3.872 7.072l.608.919.079-.115c2.01-3.009 3.41-5.468 4.217-7.402l.117-.286.103-.266A5 5 0 0012 4zm0 3a2 2 0 110 4 2 2 0 010-4z" fill="#909090"/></svg>`
};
